import type { ScalePulseTuning, WinHighlightTuning } from "@slot/presentation";

// The win sequence's VALUES (the shell's `WinSequencePresenter` and the grid's `WinHighlightEffect`). The game pays no
// line in the base game and its bonus pays through its own collection (features/board), so the server never sends a
// `grid_win_highlight`: these values are the shell's contract, in force should a round carry one. The auto-advance holds
// are live: the gap before an autospin's next spin.

export interface WinPresentationTuning {
  layer: WinHighlightTuning;
  label: { hideSeconds: number; multiplier: { holdSeconds: number; popSeconds: number; popScale: number } };
  scalePulse: ScalePulseTuning;
  winHighlightDelay: { firstSeconds: number; subsequentSeconds: number };
  autoAdvance: { postWinHoldSeconds: number; postRoundHoldSeconds: number };
}

export const WIN_PRESENTATION_TUNING: WinPresentationTuning = {
  layer: {
    cycleDurationMilliseconds: 520,
    dimStartDelayMilliseconds: 0,
    dimFadeSeconds: 0.12,
    dimExposure: -0.55,
    dimFadeEasing: "quadOut",
    dimWinners: false,
    dimEndStartDelayMilliseconds: 0,
    dimEndFadeSeconds: 0.18,
    labelInStartDelayMilliseconds: 80,
    labelOutStartDelayMilliseconds: 1200,
    labelMergeLingerMilliseconds: 400,
    labelPlacement: "clusterCenter",
    labelMode: "perWin",
    symbolAnimStaggerMilliseconds: 25,
    awaitSymbolWinAnimations: true,
  },
  label: { hideSeconds: 0.25, multiplier: { holdSeconds: 0.45, popSeconds: 0.24, popScale: 1.25 } },
  scalePulse: {
    uniformScale: true,
    scaleInStartDelayMilliseconds: 40,
    squeezeFactor: 1,
    squeezeSeconds: 0.06,
    squeezeEasing: "quadOut",
    scaleFactor: 1.15,
    scaleUpSeconds: 0.12,
    scaleUpEasing: "quadOut",
    scaleHoldSeconds: 0.06,
    scaleDownSeconds: 0.12,
    scaleDownEasing: "quadIn",
  },
  winHighlightDelay: { firstSeconds: 0.15, subsequentSeconds: 0.05 },
  autoAdvance: { postWinHoldSeconds: 0.6, postRoundHoldSeconds: 0.2 },
};
